import { IllegalArgumentException } from '../exceptions/illegal-argument.exception';
import { BaseAssertException } from '../exceptions/base-assert.exception';
import { nonNullable } from './non-nullable.assert';
import { Matchers } from '../matchers';
import { Constructor } from '../types/constructor.type';
import { that } from './that.assert';

export function isInstanceOf<T>(
  clazz: Constructor<T>,
  value: T,
  message: () => string = () => `value is not instance of ${clazz.name}`,
  construct: new (message: string) => BaseAssertException = IllegalArgumentException,
): asserts value is NonNullable<T> {
  nonNullable(clazz, () => 'class constructor must be defined', construct);
  nonNullable(value, () => 'value must be defined', construct);

  that(value, Matchers.isInstanceOf(clazz, message), construct);
}
